import { render, staticRenderFns } from "./ZpDetails.vue?vue&type=template&id=a78ffdbc&scoped=true&"
import script from "./ZpDetails.vue?vue&type=script&lang=js&"
export * from "./ZpDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a78ffdbc",
  null
  
)

export default component.exports